import { useNavigate } from "react-router-dom";
import Topo from "../Topo/topo";
import CurrencyInput from "react-currency-input-field";
import { filiadoAPI } from "../../servicos/filiado";
import { Controller, useForm } from "react-hook-form";
import { FormField } from "../ui/form-field";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Switch } from "../ui/switch";
import { Label } from "../ui/label";
import { normalizeCurrencyValue, currencyStringToCents, centsToCurrencyString } from "../../utils/currency";
import { toast } from "sonner";


function Incluir() {

    const breadcrumbs = ['Admin', 'Filiado', 'Novo'];

    const currencyInputClass = 'form-input tw-flex tw-h-11 tw-w-full tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-50 tw-px-4 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-inner tw-transition-all placeholder:tw-text-slate-400 hover:tw-border-indigo-300 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-400 focus-visible:tw-border-indigo-500 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 dark:tw-border-slate-700 dark:tw-bg-slate-800 dark:tw-text-slate-100 dark:placeholder:tw-text-slate-500 dark:hover:tw-border-indigo-400/40 dark:focus-visible:tw-ring-indigo-300/60';

    const {
        control,
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: {
            fi100_dsc_filiado: '',
            fi100_num_cnpj: '',
            fi100_dsc_email: '',
            fi100_dsc_senha: '',
            senhaConfirm: '',
            fi100_num_telefone: '',
            fi100_key_detran: '',
            fi100_dsc_senha_detran: '',
            fi100_ind_associado: false,
            fi100_vlr_emplacamento: '0.00',
            fi100_vlr_intencao_venda: '0.00',
        },
        mode: 'onBlur',
    });

    const senhaAtual = watch('fi100_dsc_senha');

    const atualizarCaretNoFinal = (input) => {
        if (!input) {
            return;
        }

        requestAnimationFrame(() => {
            const tamanho = input.value?.length ?? 0;
            try {
                input.setSelectionRange(tamanho, tamanho);
            } catch (erro) {
                // Ignora navegadores que não suportam selectionRange em tipos específicos.
            }
        });
    };

    const cursorNoFinal = (input) => {
        if (!input) {
            return false;
        }

        const { selectionStart, selectionEnd, value } = input;
        if (
            selectionStart === null ||
            selectionEnd === null ||
            selectionStart !== selectionEnd
        ) {
            return false;
        }

        return selectionStart === value.length;
    };

    const handleCurrencyKeyDown = (evento, valorAtual, onChange) => {
        const { key, target } = evento;
        if (!(target instanceof HTMLInputElement)) {
            return;
        }

        const ehNumero = /^[0-9]$/.test(key);
        const estaNoFinal = cursorNoFinal(target);

        if (ehNumero && estaNoFinal) {
            evento.preventDefault();
            const centavosAtual = currencyStringToCents(valorAtual);
            const proximoValor = centsToCurrencyString(
                Math.min(Number.MAX_SAFE_INTEGER, centavosAtual * 10 + Number(key))
            );
            onChange(proximoValor);
            atualizarCaretNoFinal(target);
            return;
        }

        if ((key === 'Backspace' || key === 'Delete') && estaNoFinal) {
            evento.preventDefault();
            const centavosAtual = currencyStringToCents(valorAtual);
            const proximoValor = centsToCurrencyString(Math.floor(centavosAtual / 10));
            onChange(proximoValor);
            atualizarCaretNoFinal(target);
        }
    };

    const removerNaoDigitos = (valor = '') => valor.replace(/\D/g, '');
    const safeTrim = (valor = '') => valor.trim();

    const formatarCnpj = (valor = '') => {
        const digitos = removerNaoDigitos(valor).slice(0, 14);

        return digitos
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2');
    };

    const validarCnpj = (valor = '') => {
        const cnpj = removerNaoDigitos(valor);
        if (cnpj.length !== 14) {
            return false;
        }
        if (/^(\d)\1{13}$/.test(cnpj)) {
            return false;
        }

        const gerarDigito = (base) => {
            let soma = 0;
            let multiplicador = 2;

            for (let i = base.length - 1; i >= 0; i -= 1) {
                soma += Number(base[i]) * multiplicador;
                multiplicador = multiplicador === 9 ? 2 : multiplicador + 1;
            }

            const resto = soma % 11;
            return resto < 2 ? 0 : 11 - resto;
        };

        const base = cnpj.slice(0, 12);
        const digito1 = gerarDigito(base);
        const digito2 = gerarDigito(base + digito1);

        return cnpj === base + digito1 + digito2;
    };

    const formatarTelefone = (valor = '') => {
        const digitos = removerNaoDigitos(valor).slice(0, 11);

        if (!digitos) {
            return '';
        }

        if (digitos.length <= 2) {
            return digitos.length === 2 ? `(${digitos}) ` : `(${digitos}`;
        }

        const ddd = digitos.slice(0, 2);

        if (digitos.length <= 6) {
            return `(${ddd}) ${digitos.slice(2)}`;
        }

        const primeiraParte = digitos.length > 10 ? digitos.slice(2, 7) : digitos.slice(2, 6);
        const segundaParte = digitos.length > 10 ? digitos.slice(7) : digitos.slice(6);

        if (segundaParte) {
            return `(${ddd}) ${primeiraParte}-${segundaParte}`;
        }

        return `(${ddd}) ${primeiraParte}`;
    };

    let navigate = useNavigate();
    const Voltar = () => {
        let path = '/admin/filiado';
        navigate(path);
    }

    const formatCurrencyToNumber = (valor) => {
        if (!valor) {
            return '0';
        }

        const trimmed = valor.trim();

        if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
            return trimmed;
        }

        return trimmed
            .replace(/\s/g, '')
            .replace(/[R$]/g, '')
            .replace(/\./g, '')
            .replace(/,/g, '.');
    };

    const onSubmit = async (values) => {
        const payload = {
            fi100_dsc_filiado: safeTrim(values.fi100_dsc_filiado),
            fi100_num_cnpj: removerNaoDigitos(values.fi100_num_cnpj),
            fi100_dsc_email: safeTrim(values.fi100_dsc_email),
            fi100_dsc_senha: values.fi100_dsc_senha,
            fi100_num_telefone: removerNaoDigitos(values.fi100_num_telefone),
            fi100_key_detran: safeTrim(values.fi100_key_detran),
            fi100_dsc_senha_detran: safeTrim(values.fi100_dsc_senha_detran),
            fi100_ind_associado: values.fi100_ind_associado,
            fi100_vlr_emplacamento: formatCurrencyToNumber(values.fi100_vlr_emplacamento),
            fi100_vlr_intencao_venda: formatCurrencyToNumber(values.fi100_vlr_intencao_venda),
        };

        try {
            await filiadoAPI.post('/', payload);
            toast.success('Filiado cadastrado com sucesso.');
            reset();
        } catch (erro) {
            let mensagem = 'Ops! Ocorreu um erro inesperado.';
            if (erro?.response?.data?.message) {
                if (erro.response?.status === 401) {
                    mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
                } else {
                    mensagem = erro.response.data.message;
                }
            } else if (erro.response?.status === 401) {
                mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
            }
            toast.error(mensagem);
        }
    };

    const onInvalidSubmit = () => {
        toast.error('Por favor, corrija os campos destacados.');
    };

    return (
        <div class="row">
            <div class="container">
                <Topo titulo='Novo Filiado' breadcrumbs={breadcrumbs} btnincluir={false} admin={true}/>
                <div class="row row-padding-conteudo">
                    <div class="col-12">
                        <form class="row gy-4 gx-4" onSubmit={handleSubmit(onSubmit, onInvalidSubmit)}>
                            <div class="col-md-6">
                                <FormField
                                    id="fi100_dsc_filiado"
                                    label="Nome do Filiado"
                                    error={errors.fi100_dsc_filiado?.message}
                                >
                                    <Input
                                        id="fi100_dsc_filiado"
                                        autoComplete="organization"
                                        {...register('fi100_dsc_filiado', {
                                            required: 'Informe o nome do filiado.',
                                            minLength: {
                                                value: 3,
                                                message: 'O nome deve possuir ao menos 3 caracteres.',
                                            },
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="fi100_num_cnpj"
                                    label="CNPJ"
                                    error={errors.fi100_num_cnpj?.message}
                                >
                                    <Controller
                                        name="fi100_num_cnpj"
                                        control={control}
                                        rules={{
                                            required: 'Informe o CNPJ.',
                                            validate: (valor) =>
                                                validarCnpj(valor) || 'CNPJ inválido.',
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                id="fi100_num_cnpj"
                                                inputMode="numeric"
                                                maxLength={18}
                                                placeholder="00.000.000/0000-00"
                                                value={field.value ?? ''}
                                                onChange={(evento) =>
                                                    field.onChange(formatarCnpj(evento.target.value))
                                                }
                                            />
                                        )}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="fi100_dsc_email"
                                    label="E-mail"
                                    error={errors.fi100_dsc_email?.message}
                                >
                                    <Input
                                        id="fi100_dsc_email"
                                        type="email"
                                        autoComplete="email"
                                        placeholder="nome@sindiloc.com.br"
                                        {...register('fi100_dsc_email', {
                                            required: 'Informe o e-mail.',
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: 'Informe um e-mail válido.',
                                            },
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="fi100_num_telefone"
                                    label="Telefone"
                                    error={errors.fi100_num_telefone?.message}
                                >
                                    <Controller
                                        name="fi100_num_telefone"
                                        control={control}
                                        rules={{
                                            validate: (valor) => {
                                                const digitos = removerNaoDigitos(valor);
                                                if (!digitos) {
                                                    return true;
                                                }
                                                return digitos.length >= 10
                                                    ? true
                                                    : 'Telefone incompleto.';
                                            },
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                id="fi100_num_telefone"
                                                inputMode="tel"
                                                placeholder="(00) 00000-0000"
                                                value={field.value ?? ''}
                                                onChange={(evento) =>
                                                    field.onChange(
                                                        formatarTelefone(evento.target.value),
                                                    )
                                                }
                                            />
                                        )}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField id="fi100_key_detran" label="Detran-PR Cliente ID">
                                    <Input
                                        id="fi100_key_detran"
                                        autoComplete="off"
                                        {...register('fi100_key_detran')}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField id="fi100_dsc_senha_detran" label="Detran-PR Client Secret">
                                    <Input
                                        id="fi100_dsc_senha_detran"
                                        autoComplete="off"
                                        {...register('fi100_dsc_senha_detran')}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="fi100_dsc_senha"
                                    label="Senha"
                                    error={errors.fi100_dsc_senha?.message}
                                >
                                    <Input
                                        id="fi100_dsc_senha"
                                        type="password"
                                        autoComplete="new-password"
                                        {...register('fi100_dsc_senha', {
                                            required: 'Informe a senha.',
                                            minLength: {
                                                value: 6,
                                                message: 'A senha deve possuir ao menos 6 caracteres.',
                                            },
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="fi100_dsc_senha_2"
                                    label="Confirmação da Senha"
                                    error={errors.senhaConfirm?.message}
                                >
                                    <Input
                                        id="fi100_dsc_senha_2"
                                        type="password"
                                        autoComplete="new-password"
                                        {...register('senhaConfirm', {
                                            required: 'Confirme a senha.',
                                            validate: (valor) =>
                                                valor === senhaAtual || 'As senhas devem estar iguais.',
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-12">
                                <div class="row gy-4 gx-4">
                                    <div class="col-12 col-md-6">
                                        <FormField
                                            id="fi100_vlr_emplacamento"
                                            label="Valor Emplacamento"
                                            error={errors.fi100_vlr_emplacamento?.message}
                                        >
                                            <Controller
                                                name="fi100_vlr_emplacamento"
                                                control={control}
                                                rules={{
                                                    required: 'Informe o valor de emplacamento.',
                                                }}
                                                render={({ field }) => (
                                                    <CurrencyInput
                                                        {...field}
                                                        id="fi100_vlr_emplacamento"
                                                        intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
                                                        allowNegativeValue={false}
                                                        disableAbbreviations={true}
                                                        decimalScale={2}
                                                        decimalsLimit={2}
                                                        fixedDecimalLength={2}
                                                        maxLength={13}
                                                        valueIsNumericString
                                                        value={field.value ?? '0.00'}
                                                        className={currencyInputClass}
                                                        onValueChange={(value) =>
                                                            field.onChange(normalizeCurrencyValue(value))
                                                        }
                                                        onKeyDown={(evento) =>
                                                            handleCurrencyKeyDown(
                                                                evento,
                                                                field.value ?? '0.00',
                                                                field.onChange,
                                                            )
                                                        }
                                                    />
                                                )}
                                            />
                                        </FormField>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <FormField
                                            id="fi100_vlr_intencao_venda"
                                            label="Valor Intenção de Venda"
                                            error={errors.fi100_vlr_intencao_venda?.message}
                                        >
                                            <Controller
                                                name="fi100_vlr_intencao_venda"
                                                control={control}
                                                rules={{
                                                    required: 'Informe o valor da intenção de venda.',
                                                }}
                                                render={({ field }) => (
                                                    <CurrencyInput
                                                        {...field}
                                                        id="fi100_vlr_intencao_venda"
                                                        intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
                                                        allowNegativeValue={false}
                                                        disableAbbreviations={true}
                                                        decimalScale={2}
                                                        decimalsLimit={2}
                                                        fixedDecimalLength={2}
                                                        maxLength={13}
                                                        valueIsNumericString
                                                        value={field.value ?? '0.00'}
                                                        className={currencyInputClass}
                                                        onValueChange={(value) =>
                                                            field.onChange(normalizeCurrencyValue(value))
                                                        }
                                                        onKeyDown={(evento) =>
                                                            handleCurrencyKeyDown(
                                                                evento,
                                                                field.value ?? '0.00',
                                                                field.onChange,
                                                            )
                                                        }
                                                    />
                                                )}
                                            />
                                        </FormField>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 tw-flex tw-items-center tw-justify-end tw-gap-3 tw-pt-2">
                                <div class="form-card tw-flex tw-flex-row tw-items-center tw-gap-4 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-sm tw-transition-colors dark:tw-border-slate-700 dark:tw-bg-slate-900">
                                    <Label htmlFor="fi100_ind_associado" className="tw-text-xs tw-uppercase tw-tracking-wide tw-text-slate-500 dark:tw-text-slate-400">
                                        Associado
                                    </Label>
                                    <Controller
                                        name="fi100_ind_associado"
                                        control={control}
                                        render={({ field }) => (
                                            <Switch
                                                id="fi100_ind_associado"
                                                checked={Boolean(field.value)}
                                                onCheckedChange={field.onChange}
                                                aria-label="Associado"
                                            />
                                        )}
                                    />
                                </div>
                                <Button
                                    type="button"
                                    variant="outline"
                                    onClick={Voltar}
                                    disabled={isSubmitting}
                                    className="tw-min-w-[120px] tw-text-slate-700 dark:tw-text-white"
                                >
                                    Voltar
                                </Button>
                                <Button type="submit" className="tw-min-w-[140px]" disabled={isSubmitting}>
                                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Incluir;
